import { render, staticRenderFns } from "./app_settings.vue?vue&type=template&id=7e137370&scoped=true&"
import script from "./app_settings.vue?vue&type=script&lang=js&"
export * from "./app_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e137370",
  null
  
)

export default component.exports